import { FC } from 'react';

import cn from 'classnames';

import type { BaseComponentProps } from '../../../types/common';

import styles from './DotAnnotation.module.css';

export type DotAnnotationProps = BaseComponentProps;
/**
   * The size of the dot annotation
/**
 * Badge component to know non-interactive status of an element
 */
export const DotAnnotation: FC<DotAnnotationProps> = ({ dataTestId }) => {
  return <div className={cn(styles.dot)} data-testid={dataTestId}></div>;
};
